<h1 mat-dialog-title>
  {{ this.data.exception ? 'Uitzondering bewerken' : 'Nieuwe uitzondering toevoegen' }}
</h1>
<div mat-dialog-content>
  <form class="exception-form" [formGroup]="exceptionForm">
    <div class="half-fields">
      <mat-form-field>
        <mat-label>Titel</mat-label>
        <input matInput formControlName="title" />
        <mat-error>{{ getError('title') }}</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Datum</mat-label>
        <input matInput formControlName="date" [matDatepicker]="date" />
        <mat-datepicker-toggle matIconSuffix aria-label="Kalender openen" [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date></mat-datepicker>
        <mat-error>{{ getError('date') }}</mat-error>
      </mat-form-field>
    </div>
    <mat-form-field>
      <mat-label>Beschrijving</mat-label>
      <textarea matInput rows="3" formControlName="description"></textarea>
    </mat-form-field>
    <mat-slide-toggle formControlName="allDay" (change)="toggleHandler('allDay')"> Hele dag </mat-slide-toggle>
    @if (!exceptionForm.controls.allDay.value) {
      <h4 class="subtitle">Van</h4>
      <div class="half-fields">
        <mat-form-field>
          <mat-label>Uur</mat-label>
          <input type="number" matInput formControlName="startHour" />
          <mat-error>{{ getError('startHour') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Minuten</mat-label>
          <input type="number" matInput formControlName="startMinutes" />
          <mat-error>{{ getError('startMinutes') }}</mat-error>
        </mat-form-field>
      </div>
      <h4 class="subtitle">Tot</h4>
      <div class="half-fields">
        <mat-form-field>
          <mat-label>Uur</mat-label>
          <input type="number" matInput formControlName="endHour" />
          <mat-error>{{ getError('endHour') }}</mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Minuten</mat-label>
          <input type="number" matInput formControlName="endMinutes" />
          <mat-error>{{ getError('endMinutes') }}</mat-error>
        </mat-form-field>
      </div>
    }
    <mat-slide-toggle formControlName="repeat" (change)="toggleHandler('repeat')">
      Herhaal deze uitzondering
    </mat-slide-toggle>
    @if (exceptionForm.controls.repeat.value) {
      <mat-form-field>
        <mat-label>Herhaal</mat-label>
        <mat-select formControlName="repeatValue">
          @for (repeatValue of repeatValues | keyvalue; track repeatValue) {
            <mat-option [value]="repeatValue.key">
              {{ repeatValue.value }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Annuleren</button>
  <button mat-flat-button [class.spinner]="saving()" [disabled]="saving()" (click)="save()">Opslaan</button>
</div>
